import { PropTypes } from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { placements, Tooltip } from '@ge/components/tooltip';
import { Placeholders } from '@ge/models/constants';
import { elevations } from '@ge/tokens/elevations';

const MessageContainer = styled.div`
  text-transform: uppercase;
  max-width: 1000px;
  text-overflow: ellipsis;
  overflow: hidden;
  .command {
    font-weight: 700;
  }
`;

export const CommandMessage = ({ command, status, desc }) => {
  const { ready, t } = useTranslation(['monitor.assets'], { useSuspense: false });

  if (!ready) {
    return Placeholders.DOUBLE_DASH;
  }

  return (
    <MessageContainer>
      <span className="command">{t(`notification.${command}`, 'Command')}</span>{' '}
      {t(`notification.${status}`)}
      {'      '}
      {desc ? (
        <Tooltip
          title={t(`${desc} `)}
          className="tooltip-cmdNotif"
          zIndex={elevations.P20}
          placement={placements.TOP}
        >
          <span>
            {t(`notification.${desc}`, ` Error Desc: `)}
            {t(`${desc} `)}
          </span>
        </Tooltip>
      ) : (
        ''
      )}
    </MessageContainer>
  );
};

CommandMessage.propTypes = {
  command: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  desc: PropTypes.string.isRequired,
};
